module.exports = __webpack_public_path__ + "static/media/back-arrow.b62a211c.svg";